export default __webpack_public_path__ + "static/media/Smiling1.9c33907b.svg";